var map = {
	"./about-us.svg": 756,
	"./betting-icon.svg": 757,
	"./bonus.svg": 758,
	"./coin.png": 759,
	"./contact-us.svg": 760,
	"./download-app.svg": 761,
	"./edit-btn.svg": 762,
	"./feedback.svg": 763,
	"./global.svg": 764,
	"./info-centre.svg": 765,
	"./mall-icon.svg": 766,
	"./message.svg": 767,
	"./redemption-icon.svg": 768,
	"./referral.svg": 769,
	"./resp-gaming.svg": 770,
	"./security.svg": 771,
	"./transaction-icon.svg": 772,
	"./vip-icon.svg": 773,
	"./wallet-icon.svg": 774
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 168;